<template>
  <div class="task-execution-status-container">
    <div class="echarts-box">
      <BarMap :rangeTime="rangeTime" :projectId="projectId" isDetail />
    </div>

    <el-table
      :data="tableData"
      v-loading="loading"
      row-key="id"
      :height="height"
      border
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="title" label="成员" min-width="60" show-overflow-tooltip class="table-children" fixed>
      </el-table-column>
      <el-table-column prop="total_number_of_tasks" label="任务总数" min-width="60">
      </el-table-column>
      <el-table-column prop="completed_number_of_tasks" label="已完成" min-width="60">
      </el-table-column>
      <el-table-column prop="undone_number_of_tasks" label="未完成" min-width="60">
      </el-table-column>
      <el-table-column prop="overdue_number_of_tasks" label="逾期" min-width="60">
      </el-table-column>
      <el-table-column prop="archived_number_of_tasks" label="已归档" min-width="60">
      </el-table-column>
    </el-table>

    <!-- <nothing v-if="!tableData.length"></nothing> -->
  </div>
</template>

<script>
import BarMap from '../../barMap'

import api from '@/services/api/statistics/statistics'

export default {
  components: {
    BarMap
  },
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    rangeTime: {
      type: [Array, Object],
      default: []
    },
  },
  data() {
    return {
      loading: false,
      height: null,
      tableData: []
    }
  },
  watch: {
    rangeTime: {
      handler() {
        this.getTableData()
      },
      deep: true
    },
    // projectId(val) {
    //   if (val) {
    //     this.init()
    //     this.getTableData()
    //   }
    // }
  },
  mounted() {
    if (this.rangeTime.length) {
      this.getTableData()
    }

    // 获取当前窗口下表格可移动的最高高度 (用窗口的高度减去其他各个元素的高度)
    this.height = window.innerHeight - 78 -337 - 16
  },
  methods: {
    getTableData() {
      this.loading = true
      let params = {
        project_id: this.projectId,
        start_time: this.rangeTime[0],
        end_time: this.rangeTime[1],
      }
      // console.log(params, 111)
      api.userTaskCompletedOverview(params).then(res => {
        let arr = []
        res.forEach((item, index) => {
          for (let key in item) {
            let children = item[key].map((res, idx) => {
              return {
                id: index + '8888' + idx,
                title: res.realname,
                total_number_of_tasks: res.total_number_of_tasks,
                completed_number_of_tasks: res.completed_number_of_tasks,
                undone_number_of_tasks: res.undone_number_of_tasks,
                overdue_number_of_tasks: res.overdue_number_of_tasks,
                archived_number_of_tasks: res.archived_number_of_tasks,
              }
            })
            // console.log(item, key, 111)
            arr.push({
              id: index + 1,
              title: key,
              total_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.total_number_of_tasks, 0) || 0,
              completed_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.completed_number_of_tasks, 0) || 0,
              undone_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.undone_number_of_tasks, 0) || 0,
              overdue_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.overdue_number_of_tasks, 0) || 0,
              archived_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.archived_number_of_tasks, 0) || 0,
              children
            })
          }
        })
        this.tableData = arr
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.task-execution-status-container {
  /deep/ .el-table__row--level-0 {
    .cell {
      font-weight: bold;
    }
  }
  /deep/ .el-table--border th:first-child .cell,
  /deep/ .el-table--border td:first-child .cell {
    padding-left: 80px;
  }

  /deep/ .el-table--border th .cell,
  /deep/ .el-table--border td .cell {
    padding-left: 24px;
  }
  /deep/ .el-table__empty-text {
    display: none;
  }
  /deep/ .el-table__fixed::before {
    height: 0;
  }
}
</style>
